// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gr138","newExpiryDate":"styles_newExpiryDate__2b2dB","footer":"styles_footer__yyyEO"};